// extracted by mini-css-extract-plugin
export var corGradientBg = "index-module--cor-gradient-bg--bda3a";
export var macContainer = "index-module--mac-container--a6b61";
export var red = "index-module--red--16df0";